import {https, httpsFile} from './http.js';

export function index(page, currentpage,sortby,sortdir, search, period) {
    return httpsFile().get(`po_config?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&period=${period}`);
}
//
// export function show(id,show){
//     return https().get(`goods_receipt/${id}?showFor=${show}`);
// }
//
export function getCurrentAssignment(period){
    return https().get(`getCurrentAssignment?period=${period}`);
}
export function getPoConfigPerMaterialGroup5(period){
    return https().get(`getPoConfigPerMaterialGroup5?period=${period}`);
}
export function getPoConfigPerCategory(period,matgroup){
    return https().get(`getPoConfigPerCategory?period=${period}&matgroup=${matgroup}`);
}
export function getPoConfigCategoryDetails(page,currentPage,matkl,period,matgroup){
    return https().get(`getPoConfigCategoryDetails?page=${page}&currentpage=${currentPage}&matkl=${matkl}&period=${period}&matgroup=${matgroup}`);
}
export function getBudget(items){
    return https().post(`getBudget`,items);
}
//
// export function showReceivingReportDetails(id){
//     return https().get(`showReceivingReport/${id}`);
// }
//
// export function receiveGoods(data){
//     return https().post(`receiveGoods`,data);
// }
//
// export function getDelivered(MATNR,EBELN,EBELP){
//     return https().get(`getDelivered?MATNR=${MATNR}&EBELN=${EBELN}&EBELP=${EBELP}`);
// }
export function getRunningPO(period){
    return https().get(`getRunningPO?period=${period}`);
}
export function getPrevSales(period){
    return https().get(`getPrevSales?period=${period}`);
}
//
// export function getRequestedQty(MATNR,EBELN){
//     return https().get(`getRequestedQty?MATNR=${MATNR}&EBELN=${EBELN}`);
// }
//
export function store(data){
    return https().post(`po_config`,data);
}
export function updatePerMvgr5(data){
    return https().post(`updatePerMvgr5`,data);
}

export function updatePerCat(data){
    return https().post(`updatePerCat`,data);
}
//
// export function saveReceivingReport(data){
//     return https().post(`saveReceivingReport`,data);
// }
//
// export function manualExport(id){
//     return https().get(`goodsReceiptManualExport?id=${id}`);
// }